export default {"src":"/_next/static/media/solar_question-circle-outline.547b6e78.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};